module.exports = __webpack_public_path__ + "static/media/GAOFEN 5.9b4b5333.czml";